import { WidgetId } from 'types/idTypes';

export enum DesignGenerationType {
  Card = 'card',
  Infograph = 'infograph',
  Poster = 'poster',
}

export type CardTemplateData = {
  e2DesignId: string;
  e1TemplateId: string;
  baseColor?: string;
  replaceables?: {
    icons?: WidgetId[];
    images?: WidgetId[];
  };
};

export type InfographicTemplateData = {
  e2DesignId: string;
  replaceables: {
    icons?: string[];
    images?: string[];
    charts?: string[];
  };
};

export type BaseTemplateData = CardTemplateData | InfographicTemplateData;

/**
 * Types for the Error handler
 */
export enum ChatErrorTypes {
  BAD_REQUEST = '400',
  INTERNAL_SERVER_ERROR = '500',
  USER_OVERLIMIT = 'overlimit',
}
